/**
 * Created by Jie Gao on 2019-02-12.
 */
export class StarStruckReelAreaEvents{

    public static readonly LIFT_REEL:string = "reelAreaEvent_liftReel";
    public static readonly SLOW_MOTION_STOP:string = "reelAreaEvent_slowMotionStop";
    public static readonly SLOW_MOTION_STOPPING:string = "reelAreaEvent_slowMotionStopping";
}